import { ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { INotificationDelegate } from '../../../global/helpers/notification_delegate';
interface ISelectedTerm {
  id: number;
  nk: string;
  name: string;
}
export class SclAddToTermDialog {
  private showDialog = false;
  private selectedTerm: ISelectedTerm;
  private selectedCourseNk = '';
  private courseCd = '';
  private courseNk = '';
  private hasPlannedTerms = false;
  constructor(
    private log: any,
    private saveCourseToTermCommand: ICommand,
    private $state: ng.ui.IStateService,
    private ngAPNotificationDelegate: INotificationDelegate,
    private ngAPTermsQuery: IQuery,
    private ngComponentCommunicatorService: CommunicatorService
  ) {}
  $onChanges() {
    this.selectedTerm = { id: -1, name: '', nk: '' };
    if (!_4.isEmpty(this.ngAPTermsQuery.result.plannedTerms)) {
      this.selectedTerm = _4.first(this.ngAPTermsQuery.result.plannedTerms);
    }
    this.hasPlannedTerms = this._hasPlannedTerms;
  }
  openDialog() {
    this.showDialog = true;
  }
  closeDialog() {
    this.showDialog = false;
  }
  get _hasPlannedTerms() {
    return _4.gt(_4.size(this.ngAPTermsQuery.result.plannedTerms), 0);
  }
  addToTerm() {
    const courseId = null;
    const slot = { id: _4.get(this.$state, 'params.slotId', null) };
    const source = 'SMART_CAT';
    const isDevReq = false;
    this.saveCourseToTermCommand(courseId, this.selectedTerm.id, slot, isDevReq, this.courseNk, source).then(() => {
      this.closeDialog();
      this.ngComponentCommunicatorService.publish('CLOSE_LARGE_COURSE_GROUP_PANEL');
      this.ngAPNotificationDelegate.success(`${this.courseCd} added to ${this.selectedTerm.name}`);
    });
  }
  updateTermSelection(evt: any, term: ISelectedTerm) {
    const isTermSelected = _4.get(evt, 'detail.value', false);
    if (isTermSelected) {
      this.selectedTerm = term;
    }
  }

  revokePopupOpenedChanged($event: any) {
    this.hasPlannedTerms = this._hasPlannedTerms;
    if (!$event.detail.value) {
      this.showDialog = false;
    }
  }
}

angular.module('capability-ng-academic-planner').component('sclAddToTermDialog', {
  templateUrl:
    'capability-ng-academic-planner/src/smart_catalog/components/scl_add_to_term_dialog/scl_add_to_term_dialog.html',
  bindings: {
    showDialog: '=',
    courseCd: '<',
    courseNk: '<'
  },
  controller: SclAddToTermDialog
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/smart_catalog/components/scl_add_to_term_dialog/scl_add_to_term_dialog.ts